import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-3 mb-4 settings-card" }
const _hoisted_2 = { class: "card-body p-4 p-xl-40" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-start justify-content-between gap-3 mb-4" }
const _hoisted_4 = { class: "settings-chip" }
const _hoisted_5 = { class: "mb-2 text-title fw-semibold mt-3" }
const _hoisted_6 = { class: "text-optional mb-0 settings-subtitle" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_9 = { class: "row g-4" }
const _hoisted_10 = { class: "col-lg-12" }
const _hoisted_11 = { class: "row g-4" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "settings-label" }
const _hoisted_14 = ["value", "placeholder"]
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "settings-label" }
const _hoisted_17 = ["value", "placeholder"]
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "settings-label" }
const _hoisted_20 = ["value", "placeholder"]
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "settings-label" }
const _hoisted_23 = ["value", "placeholder"]
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "settings-label" }
const _hoisted_26 = ["value", "placeholder"]
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "settings-label" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { value: "USD" }
const _hoisted_31 = { value: "KHR" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "settings-label" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { value: "en" }
const _hoisted_36 = { value: "km" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "settings-label" }
const _hoisted_39 = ["value", "placeholder"]
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "settings-label" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { value: null }
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "settings-label" }
const _hoisted_47 = ["value"]
const _hoisted_48 = { value: null }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "col-lg-12" }
const _hoisted_51 = { class: "settings-panel h-100" }
const _hoisted_52 = { class: "logo-upload-box row" }
const _hoisted_53 = { class: "logo-preview-area col-md-5" }
const _hoisted_54 = ["src", "alt"]
const _hoisted_55 = {
  key: 1,
  class: "logo-preview-empty"
}
const _hoisted_56 = { class: "col-md-7" }
const _hoisted_57 = { class: "settings-label" }
const _hoisted_58 = { class: "text-optional small mb-3" }
const _hoisted_59 = { class: "text-title fw-semibold mb-3" }
const _hoisted_60 = { class: "row g-3" }
const _hoisted_61 = { class: "settings-label" }
const _hoisted_62 = ["value", "onInput", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("system_settings_page.general_setup")), 1),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("system_settings_page.system_settings_title")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("system_settings_page.system_settings_description")), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn style-five px-4",
          disabled: _ctx.isSaving,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submit')))
        }, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("system_settings_page.save_settings")), 1)
        ], 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("system_settings_page.company_name")), 1),
              _createElementVNode("input", {
                value: _ctx.settings.site_name,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.patchSettings({ site_name: (($event.target as HTMLInputElement).value) }))),
                type: "text",
                class: "form-control settings-input",
                placeholder: _ctx.$t('system_settings_page.company_name_placeholder')
              }, null, 40, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("system_settings_page.company_phone")), 1),
              _createElementVNode("input", {
                value: _ctx.settings.company_phone,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.patchSettings({ company_phone: (($event.target as HTMLInputElement).value) }))),
                type: "text",
                class: "form-control settings-input",
                placeholder: _ctx.$t('system_settings_page.company_phone_placeholder')
              }, null, 40, _hoisted_17)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("system_settings_page.company_email")), 1),
              _createElementVNode("input", {
                value: _ctx.settings.company_email,
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.patchSettings({ company_email: (($event.target as HTMLInputElement).value) }))),
                type: "email",
                class: "form-control settings-input",
                placeholder: _ctx.$t('system_settings_page.company_email_placeholder')
              }, null, 40, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("system_settings_page.timezone")), 1),
              _createElementVNode("input", {
                value: _ctx.settings.timezone,
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.patchSettings({ timezone: (($event.target as HTMLInputElement).value) }))),
                type: "text",
                class: "form-control settings-input",
                placeholder: _ctx.$t('system_settings_page.timezone_placeholder')
              }, null, 40, _hoisted_23)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("system_settings_page.company_address")), 1),
              _createElementVNode("textarea", {
                value: _ctx.settings.company_address,
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.patchSettings({ company_address: (($event.target as HTMLTextAreaElement).value) }))),
                rows: "3",
                class: "form-control settings-input settings-textarea",
                placeholder: _ctx.$t('system_settings_page.company_address_placeholder')
              }, null, 40, _hoisted_26)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("system_settings_page.default_currency")), 1),
              _createElementVNode("select", {
                value: _ctx.settings.default_currency,
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.patchSettings({ default_currency: (($event.target as HTMLSelectElement).value) }))),
                class: "form-select settings-input"
              }, [
                _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t("system_settings_page.currency_usd")), 1),
                _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t("system_settings_page.currency_khr")), 1)
              ], 40, _hoisted_29)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("system_settings_page.default_language")), 1),
              _createElementVNode("select", {
                value: _ctx.settings.language,
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.patchSettings({ language: (($event.target as HTMLSelectElement).value) }))),
                class: "form-select settings-input"
              }, [
                _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.$t("system_settings_page.language_en")), 1),
                _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.$t("system_settings_page.language_km")), 1)
              ], 40, _hoisted_34)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("system_settings_page.date_format")), 1),
              _createElementVNode("input", {
                value: _ctx.settings.dateformat,
                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.patchSettings({ dateformat: (($event.target as HTMLInputElement).value) }))),
                type: "text",
                class: "form-control settings-input",
                placeholder: _ctx.$t('system_settings_page.date_format_placeholder')
              }, null, 40, _hoisted_39)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("system_settings_page.default_customer")), 1),
              _createElementVNode("select", {
                value: _ctx.settings.default_customer ?? '',
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.patchSettings({ default_customer: _ctx.parseNullableNumber(($event.target as HTMLSelectElement).value) }))),
                class: "form-select settings-input"
              }, [
                _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t("system_settings_page.walk_in_customer")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: customer.id,
                    value: customer.id
                  }, _toDisplayString(customer.name), 9, _hoisted_44))
                }), 128))
              ], 40, _hoisted_42)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("system_settings_page.default_warehouse")), 1),
              _createElementVNode("select", {
                value: _ctx.settings.default_warehouse ?? '',
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.patchSettings({ default_warehouse: _ctx.parseNullableNumber(($event.target as HTMLSelectElement).value) }))),
                class: "form-select settings-input"
              }, [
                _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.$t("system_settings_page.no_default_warehouse")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: warehouse.id,
                    value: warehouse.id
                  }, _toDisplayString(warehouse.name), 9, _hoisted_49))
                }), 128))
              ], 40, _hoisted_47)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                (_ctx.logoUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.logoUrl,
                      alt: _ctx.$t('system_settings_page.company_logo'),
                      class: "logo-preview-image"
                    }, null, 8, _hoisted_54))
                  : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "ri-image-line" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("system_settings_page.no_logo")), 1)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("system_settings_page.company_logo")), 1),
                _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t("system_settings_page.company_logo_description")), 1),
                _createElementVNode("input", {
                  type: "file",
                  class: "form-control settings-input",
                  accept: "image/*",
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onLogoChange && _ctx.onLogoChange(...args)))
                }, null, 32)
              ])
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
            _createElementVNode("h6", _hoisted_59, _toDisplayString(_ctx.$t("system_settings_page.reference_prefixes")), 1),
            _createElementVNode("div", _hoisted_60, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefixFields, (prefixField) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: prefixField.key,
                  class: "col-sm-4 col-md-3"
                }, [
                  _createElementVNode("label", _hoisted_61, _toDisplayString(prefixField.label), 1),
                  _createElementVNode("input", {
                    value: _ctx.settings[prefixField.key],
                    onInput: ($event: any) => (_ctx.patchSettings({ [prefixField.key]: (($event.target as HTMLInputElement).value) } as Partial<Setting>)),
                    type: "text",
                    class: "form-control settings-input",
                    placeholder: prefixField.placeholder
                  }, null, 40, _hoisted_62)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}